import {
  type TariffState,
  useMiniVariantTariffState
} from '@/views/variants/mini/mini-variant-tariff-state.composable'
import type { LValidationResult } from '@/libs/validation/components/LValidationForm.vue'
import { translate } from '@/i18n/i18n.ts'
import type { useUiStore } from '@/stores/ui.store.ts'
import type { useAuthStore } from '@/stores/auth.store.ts'
import type { useGlobalErrorService } from '@/services/error.service.ts'

export const useMiniVariantViewState = (
  tariffState: ReturnType<typeof useMiniVariantTariffState>,
  errorService: ReturnType<typeof useGlobalErrorService>,
  uiStore: ReturnType<typeof useUiStore>,
  authStore: ReturnType<typeof useAuthStore>
) => {
  const handleValidationResult = (result: LValidationResult) => {
    if (result.hasError) {
      showInputError()
    } else {
      uiStore.clearError()
    }
  }

  // TODO: This code is mini variant specific and should not be handled there
  const handleFormDataUpdateMini = async (result: TariffState | undefined) => {
    // @todo: find a proper way to handle this in the future
    if (!authStore.isAuthenticated()) {
      // workaround for issue when closing tab and opening tab again, then there are timing issues
      await authStore.authenticate()
    }

    if (tariffState.validationResult.value.isValid) {
      try {
        uiStore.clearError()

        await tariffState.updateOffer(result, false)

        await tariffState.fetchCurrentProductSpec()

        tariffState.updateCurrentPrice()
      } catch (error) {
        handleError(error)
      }
    } else {
      await tariffState.updateOffer(result)
      tariffState.resetProductSpec()
    }
    uiStore.setLoading(false)
  }

  function handleOnFormUpdate(data: boolean) {
    uiStore.setLoading(data)
  }

  function handleError(error: unknown) {
    tariffState.resetProductSpec()
    errorService.handleError(error)
  }

  const showInputError = () => uiStore.setError(translate('errors.check_input'))

  return {
    handleValidationResult,
    handleFormDataUpdateMini,
    handleOnFormUpdate,
    handleError,
    showInputError
  }
}
